//      
import { invariant } from '../invariant';

export default ()              => {
  const doc               = document.documentElement;
  invariant(doc, 'Cannot find document.documentElement');
  return doc;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/get-document-element.js